export default {
  placesCarousel: {
    layer: 'Ebene',
    lat: 'Breitengrad',
    lon: 'Längengrad',
    notAvailable: 'Nicht verfügbar',
    placeDetails: 'Details zum Ort',
    next: 'Nächste Seite',
    prev: 'Vorherige Seite',
    directionsTo: 'Route hierher',
    distance: 'Entfernung',
    distanceFromLocationMarkedOnTheMap: 'Ungefähre Entfernung vom auf der Karte markierten Ort',
    selectPlace: 'Auswählen'
  }
}
